import { PspPaymentOptionType } from '@bp/shared/models/business';
import type { DTO } from '@bp/shared/models/metadata';

import { BridgerPspPaymentOptionBaseSummary } from './bridger-psp-payment-option-base-summary';

export class BridgerPspPaymentOptionCreditCardSummary extends BridgerPspPaymentOptionBaseSummary {

	static override readonly type = PspPaymentOptionType.creditCard;

	readonly type = BridgerPspPaymentOptionCreditCardSummary.type;

	constructor(dto: DTO<BridgerPspPaymentOptionCreditCardSummary>) {
		super(dto);
	}

}
